import * as actionTypes from './actionTypes';

export const initialStateData = {
  userSession: {
    token: null,
    name: null,
    merchantName: null
  },
  detailsScreen: {
    userId: null,
    loanApplicationId: null,
    loanId: null,
    loanState: null,
    outgoingPaymentId: null,
    applicationNumber: null,
    lesseeName: null
  }
}

const reducer = (state = initialStateData, action) => {
  switch (action.type) {
    case actionTypes.SET_LOGGED_IN_USER:
      return {
        ...state,
        userSession: action.payload
      };

    case actionTypes.CLEAR_LOGGED_IN_USER:
      return {
        ...state,
        userSession: null
      };

    case actionTypes.SET_DETAILS_SCREEN_IDS:
      return {
        ...state,
        detailsScreen: action.payload
      };

    case actionTypes.CLEAR_DETAILS_SCREEN_IDS:
      return {
        ...state,
        detailsScreen: null
      };

    default:
      return state;
  }
}

export default reducer;
